import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import LoadingButton from "@mui/lab/LoadingButton";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import { IUserReactHookFormProps } from "interfaces";
import { TypographyHeading } from "shared/molecules/typography-layout";

import { useRef, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import {
  metadataSuccess,
  metadataUpdate,
} from "app-component/slices/metadata-slice";
import { useRouteMatch } from "react-router-dom";
import {
  getBatchFromClassIdForMs,
  getCollegeFromStateIdExtendDel,
  getSubBatchFromBatchIdForUp,
} from "utils/metadata-split/depedentApiFetch";
import {
  areArraysEqual,
  setReactFormValues,
} from "utils/metadata-split/helper";
import { emptyDeliveryList } from "pages/build-test/slices/validate-test-id";
import { isEmpty } from "utils/helpers";
import { useHistory } from "react-router-dom";
import { useStyles } from "pages/build-test/styles";
import { deliveryListMetakey } from "./helper";

const DeliveryForm = ({ ...rest }: IUserReactHookFormProps) => {
  const styles = useStyles();
  const {
    control,
    errors,
    getValues,
    setValue,
    watch,
    headerFields,
    mainFields,
    detailsFields,
    handleSubmit,
    handleRefresh,
    title,
    buttonValue,
    isLoading,
    // disableRefresh,
    mandatoryFields,
    dataSch,
    isSchedulePassed,
    isUpdate,
  } = rest;

  const history = useHistory();
  const { data } = useAppSelector((state) => state.getBuildTestDeliveryById);
  const { deliveryList } = useAppSelector((state) => state.validateTestId);

  const { refreshdata, refresherror, isLoadingrefresh } = useAppSelector(
    (state) => state.refreshDeliveryReducer
  );
  const [makeApiCall, setMakeApiCall] = useState(true);
  const [triggerSetValue, setTriggerSetValue] = useState(false);
  const deliveryData: any = data;
  const buildTestRef: any = useRef(null);
  const scrollToTop = () => {
    buildTestRef.current.scrollIntoView(false);
  };
  const dispatch = useAppDispatch();
  const match: any = useRouteMatch();
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const [fetchAll, setFetchAll] = useState(true);

  useEffect(() => {
    if (buildTestRef.current) {
      scrollToTop();
    }
  }, [buildTestRef]);

  const updateMetaData = async (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    await dispatch(metadataSuccess(metadataList));
  };

  const updateClassIdEmpty = async (listData, metaKey) => {
    setMakeApiCall(false);
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList["batch_list_ex_sch"] = [];
    metadataList["sub_batch_list_ex_sch"] = [];
    await dispatch(metadataSuccess(metadataList));
    setValue("batch_id", []);
    setValue("sub_batch_id", []);
    if (metaKey == "college_list_ex_sch" && listData?.length == 0) {
      setValue("college_id", []);
    }
  };

  const updateMetaDataMs = async (
    listData,
    metaKey,
    listData2,
    metaKey2,
    listData3,
    metaKey3
  ) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    metadataList[metaKey3] = listData3;
    await dispatch(metadataSuccess(metadataList));
    if (listData3?.length == 0) {
      setValue("sub_batch_id", []);
      // for clearing subBatch when batch is empty in form
    }
    if (metaKey == "college_list" && listData?.length == 0) {
      setValue("college_id", []);
    }
  };

  function getSelectedCollegesStates(collegeList, selectedCollegesIds) {
    return collegeList?.filter((college) =>
      selectedCollegesIds?.includes(college?.college_id)
    );
  }
  function getSelectedBatchsStates(batchList, selectedbatchsIds) {
    return batchList?.filter((batch) =>
      selectedbatchsIds?.includes(batch?.batch_id)
    );
  }

  useEffect(() => {
    if (makeApiCall && !isEmpty(dataSch)) {
      const { getExamSchedule } = dataSch;
      (async () => {
        const collegeList = await getCollegeFromStateIdExtendDel(
          watch()?.state_id,
          updateMetaData
        );
        const filteredCollges = await getSelectedCollegesStates(
          collegeList,
          getExamSchedule.college_ids
        );
        const call2 = await getBatchFromClassIdForMs(
          watch()?.class_id,
          updateMetaDataMs
        );
        const batchList=call2?call2[0]:[]
        const filteredBatches = await getSelectedBatchsStates(
          call2[0],
          getExamSchedule.batch_ids
        );
        let call3: any = [];
        if (watch()?.class_id.length > 0) {
          call3 = await getSubBatchFromBatchIdForUp(
            watch()?.batch_id,
            updateMetaDataMs
          );
          updateMetaDataMs(
            collegeList,
            deliveryListMetakey.college,
            batchList,
            deliveryListMetakey.batch,
            call3[0],
            deliveryListMetakey.sub_batch
          );
        } else {
          updateClassIdEmpty(collegeList, deliveryListMetakey.college);
        }
      })();
    } else {
      setMakeApiCall(true);
    }
  }, [watch()?.class_id, watch()?.state_id, watch()?.batch_id]);

  useEffect(() => {
    if (metaData?.batch_list_ex_sch?.length > 0 && !isLoad && triggerSetValue) {
      setTimeout(() => {
        let matchedVales = setReactFormValues(
          metaData,
          deliveryListMetakey.batch,
          watch()?.batch_id,
          "batch_id"
        );
        let isEqual = areArraysEqual(watch()?.batch_id, matchedVales);
        if (!isEqual) {
          setValue("batch_id", matchedVales);
        }
      }, 500);
    }
  }, [metaData[`${deliveryListMetakey.batch}`]]);

  useEffect(() => {
    if (metaData?.sub_batch_list_ex_sch?.length > 0 && !isLoad && triggerSetValue) {
      setTimeout(() => {
        let matchedVales = setReactFormValues(
          metaData,
          deliveryListMetakey.sub_batch,
          watch()?.sub_batch_id,
          "sub_batch_id"
        );
        let isEqual = areArraysEqual(watch()?.sub_batch_id, matchedVales);
        if (!isEqual) {
          setValue("sub_batch_id", matchedVales);
        }
      }, 500);
    }
  }, [metaData?.sub_batch_list_ex_sch]);

  useEffect(() => {
    if (metaData?.college_list_ex_sch?.length > 0 && !isLoad && triggerSetValue) {
      let matchedVales = setReactFormValues(
        metaData,
        deliveryListMetakey.college,
        watch()?.college_id,
        "college_id"
      );
      let isEqual = areArraysEqual(watch()?.college_id, matchedVales);
      if (!isEqual) {
        setValue("college_id", matchedVales);
      }
    }
  }, [metaData[`${deliveryListMetakey.college}`]]);

  const handleEdit = (id) => {
    history.push(`/build-test/edit-delivery?deliveryId=${id.delivery_id}`);
  };

  useEffect(() => {
    setTimeout(() => {
      setTriggerSetValue(true);
    }, 3000);
  }, []);

  useEffect(() => {
    dispatch(emptyDeliveryList([]));
  }, []);

  return (
    <>
      <Container>
        <Grid
          ref={buildTestRef}
          sx={{ p: 3, mt: 2, borderRadius: 1 }}
          className={styles.createDelivery}
        >
          <TypographyHeading>{title}</TypographyHeading>
          <Grid container spacing={2} sx={{ pb: 2 }}>
            <DynamicForm
              fields={headerFields}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              watch={watch}
            />
          </Grid>
        </Grid>
        <Grid
          sx={{ p: 3, mt: 2, borderRadius: 1 }}
          className={styles.buildTestDeliveryDate}
        >
          <TypographyHeading>Build Test delivery Date</TypographyHeading>
          <Grid container spacing={2}>
            <DynamicForm
              fields={mainFields}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              watch={watch}
            />
          </Grid>
        </Grid>
        <Grid
          sx={{ p: 3, mt: 2, borderRadius: 1 }}
          className={styles.buildTestItemProperties}
        >
          <TypographyHeading>Build Test Delivery properties</TypographyHeading>
          <Grid container spacing={2}>
            <DynamicForm
              fields={detailsFields}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              watch={watch}
            />
          </Grid>
        </Grid>
        {/* <Typography sx={{ mt: 2 }} className={styles.noteMsg}>
          Note: One Warm-up Delivery Id can be associated with only one
          scheduled test delivery.
        </Typography> */}
        <ContentRight>
          <LoadingButton
            variant="contained"
            color="primary"
            type="submit"
            loadingPosition="start"
            loading={isLoading}
            onClick={handleSubmit}
            disabled={
              isUpdate
                ? !isFieldsValidate(errors, mandatoryFields, getValues) || isSchedulePassed
                : !isFieldsValidate(errors, mandatoryFields, getValues)
            }
            size="small"
            sx={{ mt: 5 }}
            className={styles.addDeliveryBtn}
          >
            {buttonValue}
          </LoadingButton>
        </ContentRight>
      </Container>
    </>
  );
};

export default DeliveryForm;
